import { Component } from '@angular/core';
import { loadPagingPrefs } from '@nucleus/ui-base';

/**
 * Tasksense thin shell — heavy lifting (filter/sort/page/permissions/etc.)
 * lives in &lt;lib-users-list&gt; from @nucleus/user-ui. NUCLEUS_USER_UI_PROVIDERS
 * is registered at the AdministrationModule level so siblings (UserComponent)
 * see the same adapter graph.
 */
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.css',
  standalone: false,
})
export class UsersComponent {
  dataSetSize = 0;
  readonly defaultPageSize = loadPagingPrefs().defaultPageSize;
}
